import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase"; // Adjust path as needed
import toast from "react-hot-toast";
import { sendQueryEmail } from "./emailService";


export const raiseQuery = async (
  clientPAN,
  clientName,
  phone,
  raisedOn,
  status,
  userType,
  queryValue,
  resolution,
  deleteOn
) => {
  try {
    // 1. Get user data with fallbacks
    let userCity = "Unknown";
    try {
      const userDoc = await getDoc(doc(db, "users", clientPAN));
      userCity = userDoc.exists() ? userDoc.data().city || "Unknown" : "Unknown";
    } catch (error) {
      console.warn("Failed to fetch user city:", error);
    }

    // 2. Save to Firestore first
    const docRef = doc(db, "queries", clientPAN);
    const queryData = {
      clientName,
      pan: clientPAN,
      phone,
      raisedOn,
      status,
      userType,
      query: queryValue,
      resolution,
      deleteOn,
      city: userCity,
      notificationStatus: "pending",
      createdAt: new Date()
    };

    await setDoc(docRef, queryData);

    // 3. Attempt email notification
    let emailResult;
    try {
      emailResult = await sendQueryEmail({
        name: clientName,
        pan: clientPAN,
        phone,
        city: userCity
      }, queryValue);

      // Ensure all fields have values before updating
      const updateData = {
        notificationStatus: emailResult.success ? "sent" : "failed",
        notificationDetails: {
          team: emailResult.team || "unknown",
          recipients: emailResult.recipients || [],
          error: emailResult.error || null
        }
      };

      await updateDoc(docRef, updateData);

      if (!emailResult.success) {
        console.warn("Email notification failed:", emailResult.error);
      }
    } catch (emailError) {
      console.error("Email process failed:", emailError);
      await updateDoc(docRef, {
        notificationStatus: "failed",
        notificationDetails: {
          error: emailError.message
        }
      });
    }

    toast.success(
      `Query submitted successfully! ${emailResult?.success ? "" : "(Notification pending)"}`,
      { duration: 4000 }
    );
    
    return true;
  } catch (error) {
    console.error("Query submission failed:", error);
    toast.error(
      `Query saved but system encountered an issue. Reference: ${clientPAN.slice(-4)}`,
      { duration: 5000 }
    );
    return false;
  }
};